import { MButton } from '@Components/Base';

import { ReactComponent as ShoppingBagIcon } from '@Icons/additional/shopping-bag-gradient.svg';
import classNames from 'classnames';

import styles from './OverviewButton.module.css';

interface OverviewButton {
  count: string | number;
  onclick: () => void;
}

const OverviewButton: React.FC<OverviewButton> = ({ count, onclick }) => {
  return (
    <MButton
      className={classNames(styles.button, 'trojan-neumorphism-box')}
      onClick={onclick}
    >
      <ShoppingBagIcon className={styles.icon} />{' '}
      <span className={styles.count}>{count}</span>
    </MButton>
  );
};

export default OverviewButton;
